import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { DOMAIN_FOR_SELECT_AB_TEST_FRAGMENT } from './fragment'
import { Data, Variables } from './types'

export const GET_DOMAINS_FOR_AB_TEST: TypedDocumentNode<Data, Variables> = gql`
  ${DOMAIN_FOR_SELECT_AB_TEST_FRAGMENT}

  query getDomainsForAbTest($workspaceId: ID!) {
    domains(workspaceId: $workspaceId) {
      nodes {
        ...DomainForSelectABTestFragment
      }
    }
  }
`
